import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {Workbook as wb} from "exceljs";
import {ModificacionMarcionesService} from "../../../horas-extras/services/modificacion-marcaciones.service";
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import {
  ReportePerformService
} from "../../services/reporte-perform-services/parametro-conciliacion-bancaria.service";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import { SeguimientoUserService } from '../../services/orden-proceso-services/seguimiento-user.service';

@Component({
  selector: 'app-reporte-perform',
  templateUrl: './reporte-perform-sended.component.html',
  styleUrls: ['./reporte-perform-sended.component.css']
})
export class ReportePerformSendedComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: string = 'ListaCobros';
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioExtractos: FormGroup;
  loading: boolean = false;
  loading2: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;

  gridApiPedidos: any;
  gridColumnApiPedidos: any;
  rowDataPedidos: any[];
  rowSelectionPedidos: any;
  columnDefsPedidos: any[];
  frameworkComponentsPedidos: any;

  gridApiExtractos: any;
  gridColumnApiExtractos: any;
  rowDataExtractos: any[];
  rowSelectionExtractos: any;
  columnDefsExtractos: any[];
  frameworkComponentsExtractos: any;

  mostrarView : boolean = false;


  rowSelected: any;
  rowSelectedExtractos: any;


  obligatorylocality: boolean = false;
  today: any;
  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  mostrarTabla = false;
  recursosHumanos = false;
  @ViewChild('fileInput') fileInput: ElementRef;

  cmbEan14: any[] = [];
  cmbLote: any[] = [];
  cmbEstado: any[] = [{clave:"0",valor:"PENDIENTE"},
                      {clave:"1",valor:"ENTREGA MANUAL KOSMOS"},
                      {clave:"2",valor:"ENTREGA MANUAL SAP"},
                      {clave:"3",valor:"ENTREGA AUTOMATICA"},
                      {clave:"4",valor:"ERROR"}]

  break = false;


  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _paramReporte: ReportePerformService,
    private _datosMaestros: DatosMaestrosService,
    private _logServices : SeguimientoUserService,
  ) {
    this.diccionarioModulo = moduloPerform;
  }

  URI: string = 'REPORTE PERFOR CON SOLICITUDO'; //Ticket 30238 LOG de ingreso en modulos perform

  ngOnInit(): void {
    this._logServices.saveSeguimientoPerform(this.URI);

    this.DAT_BTNS = moduloPerform.button.buttonsNombre;
    this.DAT_TITULOS = 'Reporte perfor con solicitud';
    this.DAT_BTNCSS = moduloPerform.button.buttonsCss;
    this.DAT_MSG = moduloPerform.mensajes;
    this.titulo = 'Reporte perfor con solicitud';
    this.formulario = this.fb.group({
      lote: '',
      idMaterial: '',
    });
    this.formularioExtractos = this.fb.group({
      idBanco: '',
    });
    this.girdComponent();
    this.girdComponentPedidos();
    this.cargarPerformReporte();
    //this.mostrarView = true;
  }

  validateForm() {
    return !(this.gridApiExtractos && this.gridApiExtractos.getSelectedRows() && this.gridApiExtractos.getSelectedRows().length > 0);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  llenarCombos() {
    this.cargarTipoPago();
    this.cargarAgencia();
  }

  onGridReadyPedidos(params) {
    this.gridApiPedidos = params.api;
    this.gridColumnApiPedidos = params.columnApi;
  }

  onGridReadyExtractos(params) {
    this.gridApiExtractos = params.api;
    this.gridColumnApiExtractos = params.columnApi;
  }

  cargarPerformReporte(){
    this._paramReporte.getAllReportSended().subscribe((resp) => {
      //this.cmbBanco = this.concatenarBancoId(resp);
      this.mostrarTabla = true;
      this.rowData = resp;
    }, (error) => {
      //this.cmbBanco = [];
      console.log(error);
    });
  }

  findPerformReporte(){
    this._paramReporte.findAllReportSended(this.formulario.get('lote').value,this.formulario.get('idMaterial').value).subscribe((resp) => {
      //this.cmbBanco = this.concatenarBancoId(resp);
      this.mostrarTabla = true;
      this.rowData = resp;
    }, (error) => {
      //this.cmbBanco = [];
      console.log(error);
    });
  }



  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.procesarExtractos.bind(this),
          label: 'Ver',
          colorBoton: this.DAT_BTNCSS.info
        }
      },/*
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.verPedidos.bind(this),
          label: this.DAT_BTNS.verPedidos,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.rechazarCobro.bind(this),
          label: this.DAT_BTNS.rechazar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },*/
      {
        headerName: 'LOTE',
        field: 'lote',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ID MATERIAL',
        field: 'idMaterial',
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'DESCRIPCION',
        field: 'descMaterial',
        sortable: true,
        filter: true,
        width: 350
      },
      {
        headerName: 'EAN14',
        field: 'ean14',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Cantidad Plan',
        field: 'cantidadPlaneada',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Entrega Pendiente',
        field: 'entregaPendiente',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Entrega Automatica',
        field: 'entregaAutormatica',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Entrega M. Kosmos',
        field: 'entregaManualKsomos',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Entrega M. SAP',
        field: 'entregaManualSap',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Entrega Error',
        field: 'entregaError',
        sortable: true,
        filter: true,
        width: 200
      },
      /**/
    ];
    this.rowSelection = 'single';
  }


  girdComponentPedidos() {
    this.frameworkComponentsPedidos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsPedidos = [
      {
        headerName: 'Material',
        field: 'codSap',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'EAN14',
        field: 'ean14',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'FECHA R.',
        field: 'fechaRasp',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'FECHA S.',
        field: 'fechaTVC',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'LOTE',
        field: 'lote',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'PESO BALANZA',
        field: 'pesoBalanza',
        sortable: true,
        filter: true,
        width: 200
      },{
        headerName: 'ESTADO',
        field: 'enviadoSAP',
        sortable: true,
        filter: true,
        width: 200,
        valueGetter: function (params) {
          // debugger
          let data = params.data;
          switch(data.enviadoSAP){
            case 0:
              return "PENDIENTE";
            case 1:
              return "ENTREGA M. KOSMOS";
            case 2:
              return "ENTREGA M. SAP";
            case 3:
              return "ENTREGA AUTOMATICA";
            case 4:
              return "ERROR";
            default:
              return "UNDEFINDED";           
          }

      }
    }
    ];
    this.rowSelectionPedidos = 'single';
  }

  obtainDate(){
    this.formulario.get('lote').setValue("");
    this.formulario.get('ean14').setValue("");
    this.cmbLote = [];

    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindCodigoEan(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('lote').value,
                                          this.formulario.get('estado').value,
                                        "").subscribe((resp) => {
        this.cmbEan14 = resp.sort((a, b) => b.clave.localeCompare(a.clave));
      }, (error) => {
        this.cmbEan14 = [];
        console.log(error);
      });
    }
  }

  obtainLote(){
    this.formulario.get('lote').setValue("");
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindCodigoLote(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          this.formulario.get('estado').value,
                                        "").subscribe((resp) => {
        this.cmbLote = resp.sort();
      }, (error) => {
        this.cmbLote = [];
        console.log(error);
      });
    }
  }

  generarReport(){
    this.loading = true;
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindReport(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          this.formulario.get('lote').value,
                                          this.formulario.get('estado').value).subscribe((resp) => {
        this.rowData = resp;
        this.mostrarTabla = true;
        this.loading = false;
      }, (error) => {
        this.rowData = [];
        this.loading = false;
        console.log(error);
      });
    }
  }


  girdComponentExtractos() {
    this.frameworkComponentsExtractos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsExtractos = [
      {
        headerName: '',
        sortable: true,
        filter: true,
        width: 300,
        checkboxSelection: true,
      },
      {
        headerName: 'BANCO ID',
        field: 'idBanco',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'CUENTA',
        field: 'cuentaBancaria',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'FECHA EXTRACTO',
        field: 'fechaExtracto',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'NUMERO EXTRACTO',
        field: 'numeroExtracto',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'NUMERO REFERENCIA',
        field: 'numeroReferencia',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'MONTO',
        field: 'monto',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelectionExtractos = 'multiple';
  }


  rechazarCobro({rowData}) {
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.rechazar,
        text: ``,
        action: this.DAT_BTNS.rechazar,
        funcion: this._paramReporte.rechazarCobro(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  procesarExtractos({rowData}) {
    this.rowDataPedidos =[];
    this.mostrarView = true;
    this.loading2 = true;
    console.log(rowData);
    this._paramReporte.findAllDetail(rowData.lote,rowData.idMaterial).subscribe((resp) => {
      //this.cmbBanco = this.concatenarBancoId(resp);
      this.rowDataPedidos = resp;
      this.loading2 = false;
    }, (error) => {
      //this.cmbBanco = [];
      this.rowDataPedidos =[];
      this.loading = false;
      console.log(error);
    });
  }

 

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }


  cargarTipoPago() {
    this._datosMaestros.getAllTipoPago().subscribe((resp) => {
      //this.cmbTipoPago = resp;
    }, (error) => {
      //this.cmbTipoPago = [];
      console.log(error);
    });
  }

  cargarAgencia() {
    this._datosMaestros.getAllOficinasVentas().subscribe((resp) => {
      //this.cmbAgencia = resp;
    }, (error) => {
      //this.cmbAgencia = [];
      console.log(error);
    });
  }

  procesarExtractosClick() {
    this.loading = true;
    //this.rowSelectedExtractos = rowData;

    this.rowSelectedExtractos = this.gridApiExtractos.getSelectedRows();

    let conciliacionDatos = this.rowSelectedExtractos.map(data =>
      ({
        idEmpresa: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagEmpresa ? this.rowSelected.pagoDetalle.pagEmpresa : '',
        idBanco: this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
        claveBanco: data && data.claveBanco ? data.claveBanco : '',
        //cuentaBancaria: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagCtaBancaria ? this.rowSelected.pagoDetalle.pagCtaBancaria : '',
        cuentaBancaria: data && data.cuentaBancaria ? data.cuentaBancaria : '',
        numeroExtracto: data && data.numeroExtracto ? data.numeroExtracto : '',
        numeroReferencia: data && data.numeroReferencia ? data.numeroReferencia : '',
        idConciBancaDeta: data && data.idConciBancaDeta ? data.idConciBancaDeta : '',
      })
    );
    let payload = {
      cobroId: this.rowSelected && this.rowSelected.cobro && this.rowSelected.cobro.cobroId ? this.rowSelected.cobro.cobroId : '',
      pagConsecutivo: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagConsecutivo ? this.rowSelected.pagoDetalle.pagConsecutivo : 1,
      conciliacionDatos: conciliacionDatos
    };
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.procesar,
        text: ``,
        action: this.DAT_BTNS.procesar,
        funcion: this._paramReporte.procesarCobro(payload),
      }
    ).then((res: any) => {
        this.loading = false;
        //this.cargarCobros();
        this.regresar();
      }, () => {
        this.loading = false;
      }
    );
  }

  getExtractos(data) {
    let payload = {
      'fechaExtracto': this.formulario && this.formulario.get('date') && this.formulario.get('date').value ? this.formulario.get('date').value : '',
      'idBanco': this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
      'idEmpresa': data && data.pagoDetalle && data.pagoDetalle.pagEmpresa ? data.pagoDetalle.pagEmpresa : '',
    };
    this.rowSelected = data;
    this.loading = true;
    this._paramReporte.getAllExtractoBancario(payload).subscribe((res: any) => {
      this.rowDataExtractos = res.map(data => (
        {
          ...data,
        }
      ));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowDataExtractos = [];
    });
  }

  verPedidos({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardPedidos;
    this.mostrarGridLista = 'ListaPedidos';
    this.rowSelected = rowData;
    this.rowDataPedidos = rowData.cobro.pedidos.map(data => (
      {
        ...data,
        rowData: this.rowSelected
      }
    ));
    this.girdComponentPedidos();
  }


  regresar() {
    this.formularioExtractos.reset();
    this.mostrarGridLista = 'ListaCobros';
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }


  acciones(event) {
    if (event === 'guardar') {
      this.procesarExtractosClick();
    } else {
      //this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarView = false;
    }
  }

  exportCSV() {
    if(this.rowData === undefined || this.rowData.length === 0)
      return;
    const header: any[] = [["CANTIDAD","EAN14","ID_METRIAL","DESCRIPCION_MATERIAL","LOTE" ,"ESTADO"]];
    const listAux: any[] = this.rowData.map((item) => Object.assign({}, item));
    console.log(this.rowData);
    const body: any[] = listAux.map(item => {
      switch(item.estado){
        case 1:
          item.estado = "CORRECTO";
          break;
        case 2:
          item.estado ="RECH. BAJO PESO";
          break;
        case 3:
          item.estado ="RECH. SOBRE PESO";
          break;
        case 4:
          item.estado ="RECH. CAJA ABIERTA";
          break;
        case 5:
          item.estado ="RECH. COD NO REGISTRADO";
          break;
        case 6:
          item.estado ="RECH. COD NO DEFINIDO"; 
          break;
        default:
          item.estado ="UNDEFINDED";           
      }
      return {
        cantidad: item.cantidad,
        ean14: item.ean14,
        idMaterial: item.idMaterial,
        descMaterial: item.descMaterial,
        lote: item.lote,
        estado:item.estado,
      }
    });
    this._util.exportCSV(header, body, "Reporte_Perform.csv");
  }

}
